import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { RootState } from '~/store/store';
import { getRelativeGetStore } from '~/store/utils';
import { State, ApplicationError } from './models';

const initialState: State = {
  errors: [],
  errorsInSession: [],
};

export const errors = createSlice({
  name: 'errors',
  initialState: initialState,
  reducers: {
    addError: (state, action: PayloadAction<ApplicationError>) => {
      const { payload: error } = action;

      const newError = { id: v4(), ...error };

      state.errors.push(newError);
      state.errorsInSession.push(newError);
    },
    deleteError: (state, action: PayloadAction<string>) => {
      state.errors = state.errors.filter(({ id }) => id !== action.payload);
    },
  },
});

export const getStore = getRelativeGetStore<Partial<State>>((store: RootState) => store.errors);

export const { addError, deleteError } = errors.actions;

export default errors.reducer;
